export default __webpack_public_path__ + "static/media/qr_link.ba47d78c.jpeg";